import * as React from 'react';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import Paper from '@mui/material/Paper';

import { StyledTableCell } from '../CustomStyles/StyledTable';
import { SideDrawerHeader } from './SideGrawerConstants';

const Header = (props) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 'auto' }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
                {SideDrawerHeader.DATE}
                <br />
                {moment(props.date).format('DD-MM-YYYY')}
              </StyledTableCell>
              <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
                {SideDrawerHeader.IN_TIME} <br />
                {props.inTime}
              </StyledTableCell>
              <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
                {SideDrawerHeader.OUT_TIME} <br />
                {props.outTime}
              </StyledTableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
    </>
  );
};
export default Header;
